/*
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function () {});

$(window).on("load", function () {
  // Homepage ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (
    window.location.pathname == $(".Header__LogoLink").attr("href") ||
    window.location.pathname == $(".Header__LogoLink").attr("href") + "/"
    /*window.location.pathname == "/" ||
    window.location.pathname == "/es" ||
    window.location.pathname == "/es/" ||
    window.location.pathname == "/de" ||
    window.location.pathname == "/de/" ||
    window.location.pathname == "/fr" ||
    window.location.pathname == "/fr/" ||
    window.location.pathname == "/pt" ||
    window.location.pathname == "/pt/" ||
    window.location.pathname == "/pt-pt" ||
    window.location.pathname == "/pt-pt/" ||
    window.location.pathname == "/PT-pt" ||
    window.location.pathname == "/PT-pt/" ||
    window.location.pathname == "/pt-PT" ||
    window.location.pathname == "/pt-PT/" ||
    window.location.pathname == "/PT-PT" ||
    window.location.pathname == "/PT-PT/"*/
  ) {
    // Acrescentar barra no topo sticky com modalidades
    var sportsArray = [];
    $(".Header__MainNav .Linklist a").each(function (i) {
      if ($(this).attr("href").indexOf("collections") > -1) {
        var sport = [];
        sport.push($(this).attr("href"));
        sport.push($(this).text().trim());
        sportsArray.push(sport);
      }
    });
    var sportsHtmlPrefix =
      "<div class='sportsBannerHomepage'><div class='sportsBannerHomepageOutter'>";
    var sportsHtml = "";
    var sportsHtmlSuffix = "<div/><div/>";
    for (let i = 0; i < sportsArray.length; i++) {
      sportsHtml +=
        "<a class='sportsBannerHomepageInside Button Button--secondary' href='" +
        sportsArray[i][0] +
        "'>" +
        sportsArray[i][1] +
        "</a>";
    }
    $("#main").prepend(sportsHtmlPrefix + sportsHtml + sportsHtmlSuffix);
    if ($(window).width() >= 1140) {
      var bannerHeight = $(".sportsBannerHomepage").outerHeight();
      bannerHeight -= bannerHeight * 2;
      $(".sportsBannerHomepage").css("margin-top", bannerHeight);
    }

    // Acrescentar secção no final com modalidades
    var sportsBottomHtmlPrefix =
      '<div class="shopify-section shopify-section--bordered"><section class="Section Section--spacingNormal"><div class="Container"><header class="SectionHeader SectionHeader--center"><h3 class="SectionHeader__SubHeading Heading u-h6">Select your sport</h3><h2 class="SectionHeader__Heading Heading u-h1">View all products</h2></header><div class="Rte sportsBottomBannerHomepage">';
    var sportsBottomHtml = "";
    var sportsBottomHtmlSuffix = "</div></div></section></div>";
    for (let i = 0; i < sportsArray.length; i++) {
      sportsBottomHtml +=
        "<a class='sportsBottomBannerHomepageInside Button Button--small Button--secondary' href='" +
        sportsArray[i][0] +
        "'>" +
        sportsArray[i][1] +
        "</a>";
    }
    $("#main").append(
      sportsBottomHtmlPrefix + sportsBottomHtml + sportsBottomHtmlSuffix
    );

    // Trocar ordem da secção "Reviews" com "View all products"
    $("#stamped-main-widget")
      .parent()
      .parent()
      .parent()
      .parent()
      .detach()
      .appendTo($("#main"));
    
    // Retirar overlay no desktop
    if ($(window).width() > 640) {
      //$("main .shopify-section:nth-child(1) .Slideshow__Slide  > div").removeClass("Image--contrast");
    }

    // Baixar opacidade do Image--contraste
    $(".SectionHeader__Heading").each(function (i) {
      var value = "@";
      if ($(this).html().includes(value)) {
        var text = $(this).html();
        text = text.replaceAll(value, "<br>");
        $(this).html(text);
        $(this)
          .parent()
          .parent()
          .siblings(".Slideshow__ImageContainer")
          .addClass("withOpacity");
      }
    });

    // Adicionar parágrafo na frase do primeiro slideshow
    //$("main .shopify-section:nth-child(1) .SectionHeader__Heading").html($("main .shopify-section:nth-child(1) .SectionHeader__Heading").text().replace(/([a-zA-Z]+[.,]? ){2}/, function(x) { return x + '<br>'; }));

    // Substituir ' / ' por nova linha
    $(".SectionHeader__Heading, .SectionHeader__SubHeading").each(function (i) {
      var value = " / ";
      if ($(this).html().includes(value)) {
        var text = $(this).html();
        text = text.replaceAll(value, "<br>");
        $(this).html(text);
      }
    });

    // Substituir texto por elementos
    var stylesConfig = {
        'x': {
            startIndicator: '/x1',
            endIndicator: '/x2',
            style: 'text-decoration: line-through;'
        },
        'orange': {
            startIndicator: '/orange1',
            endIndicator: '/orange2',
            style: 'color: var(--button-background);'
        },
        'blue': {
            startIndicator: '/blue1',
            endIndicator: '/blue2',
            style: 'color: var(--link-color);'
        }
    };
    function applyDynamicStyles(config) {
        $(".FeatureText").not("script, style").each(function() {
            var oldHtml = $(this).html();
            $.each(config, function(key, value) {
                if (oldHtml.includes(value.startIndicator) && oldHtml.includes(value.endIndicator)) {
                    var startTag = '<span style="' + value.style + '">';
                    var endTag = '</span>';
                    oldHtml = oldHtml.replaceAll(value.startIndicator, startTag)
                                     .replaceAll(value.endIndicator, endTag);
                }
            });
            $(this).html(oldHtml);
        });
    }
    applyDynamicStyles(stylesConfig);
    

    // Substituir '$' para retirar overlay em mobile
    $(".SectionHeader__Heading").each(function (i) {
      if ($(this).html().includes("$")) {
        if ($(window).width() > 640 && $(this).html().includes("$+")) {
          $(this)
            .parent()
            .parent()
            .siblings(".Slideshow__ImageContainer")
            .removeClass("Image--contrast");
        }
        if ($(window).width() <= 640 && $(this).html().includes("$-")) {
          $(this)
            .parent()
            .parent()
            .siblings(".Slideshow__ImageContainer")
            .removeClass("Image--contrast");
        }
        var text = $(this).html();
        text = text.replaceAll("$+", "").replaceAll("$-", "");
        $(this).html(text);
      }
    });

    // Rotação de logos de parceiros abaixo da frase inicial
    if (true) {
      var initialDelay = 1000;
      var refreshInterval = 2500;
      var clubDelay = 150;

      var sectionIndex = 3;
      //var sectionIndex = 4;
  
      var notClicked = true;
  
      var numberOfClubs = 6;
      if ($(window).width() <= 640) {
        numberOfClubs--;
        if ($(window).width() <= 400) {
          numberOfClubs--;
        }
      }
      var logosArrayIndex = 0;
  
      var linkPrefix = "https://cdn.shopify.com/s/files/1/2171/2773/files/club-";
      var linkSuffix = ".png";
  
      var preHTML =
        '<div class="SectionHeader__SubHeading Heading u-h6 trusted-by"><ls-static-7736188888>Trusted by</ls-static-7736188888></div><div class="big-wrapper"><div class="big-wrapper-arrow-left"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather-icon"><polyline points="15 18 9 12 15 6"></polyline></svg></div><div class="club-big-wrapper">';
      var posHTML =
        '</div><div class="big-wrapper-arrow-right"><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="feather-icon"><polyline points="9 18 15 12 9 6"></polyline></svg></div></div>';
      var HTML = "";
      //var opacity = 0.6;
      var opacity = 0.999;
      var top = "10px";
  
      // Introduzir por ordem de importância
      var logosArray = [
        /*["GB","1","eufa","EUFA"],*/
        ["GB", "1", "fa", "The<br>Football<br>Association"],
        ["GB", "1", "wolver", "Wolverhampton<br>WFC"],
        ["GB", "1", "manchester", "Manchester<br>United FC"],
        ["GB", "1", "forest", "N Forest<br>FC"],
        ["GB", "1", "rangers", "Rangers<br>FC"],
        ["GB", "1", "fulham", "Fulham FC"],
        ["GB", "0", "reading", "Reading FC"],
        ["GB", "0", "middlesbrough", "Middlesbrough<br>FC"],
        ["NL", "1", "ajax", "AFC Ajax"],
        ["FR", "1", "fff", "French<br>Football<br>Federation"],
        /*["FR","1","psg","Paris<br>Saint-Germain<br>FC"],*/
        ["FR", "1", "bordeaux", "FC<br>Girondins<br>de Bordeaux"],
        ["FR", "0", "muteste", "RC Strasbourg<br>Alsace"],
        ["FR", "0", "monaco", "AS<br>Monaco<br>FC"],
        ["FR", "0", "scpparis", "Sporting<br>CP Paris"],
        ["PT", "0", "fpf", "Portuguese<br>Football<br>Federation"],
        ["PT", "1", "slb", "SL Benfica"],
        ["PT", "1", "scp", "Sporting<br>CP"],
        ["PT", "1", "fcp", "FC Porto"],
        ["PT", "0", "scb", "SC Braga"],
        ["LU", "0", "flf", "Luxembourg<br>Football<br>Federation"],
        ["LU", "0", "fcetzella", "FC Etzella<br>Ettelbrück"],
        ["LU", "1", "diddeleng", "F91<br>Diddeleng"],
        ["IT", "1", "spezia", "Spezia<br>Calcio"],
        ["IT", "0", "pescara-calcio", "Pescara<br>Calcio"],
        ["UA", "1", "shakhtar-donest", "FC<br>Shakhtar<br>Donetsk"],
        ["ES", "0", "santiago", "CD<br>Santiago"],
        ["ES", "0", "intermovistar", "Inter FS"],
        ["BE", "0", "chatelineau", "Futsal<br>Chatelineau"],
        ["BE", "0", "halle-gooik", "Halle<br>Gooik"],
        ["BR", "1", "flamengo", "CR<br>Flamengo"],
        ["BR", "0", "fluminense", "CF<br>Fluminense"],
        ["BR", "0", "gremio", "Grêmio FPA"],
        ["CZ", "1", "sparta", "AC Sparta<br>Praha"],
        ["HR", "0", "hns", "Croatian<br>Football<br>Federation"],
        ["KZ", "0", "ffk", "Kazakhstan<br>Football<br>Federation"],
        ["CZ", "0", "facr", "Football<br>Association<br>Czech Rep."],
        ["CO", "0", "fcf", "Columbian<br>Football<br>Federation"],
        ["AE", "0", "alahli", "Shabab<br>Alahli"],
        ["SI", "0", "slovenija", "Slovenian<br>Football<br>Association"],
        ["AO", "0", "cd1a", "CD<br>1º de Agosto"],
        ["US", "0", "lms", "Major League<br>Soccer"],
        ["US", "0", "orlando-city", "Orlando City"],
        ["FI", "0", "peimari-united", "Peimari United"],
        ["IR", "0", "tractor", "Tractor SC"],
        ["MZ", "0", "ldm", "Liga<br>Desportiva<br>Maputo"],
        ["QA", "0", "qfa", "Qatar<br>Football<br>Association"],
        ["QA", "0", "alsadd", "Al-Sadd SC"],
        ["QA", "0", "alarabi", "Al-Arabi SC"],
        ["KW", "0", "kfa", "Kuwait<br>Football<br>Association"],
        ["RO", "0", "frf", "Romanian<br>Football<br>Federation"],
      ];
      var newLogosArray = [];
      var newLogosArrayCountry = [];
  
      function writeNewArray(handle) {
        for (i = 0; i < logosArray.length; i++) {
          if (logosArray[i][0] == handle) {
            newLogosArray.push(logosArray[i]);
          } else {
            if (logosArray[i][1] == 1) {
              newLogosArrayCountry.push(logosArray[i]);
            }
          }
        }
        newLogosArray = newLogosArray.concat(newLogosArrayCountry);
      }
  
      jQuery
        .getJSON(
          "/browsing_context_suggestions.json?source=geolocation_recommendation&currency[enabled]=true&currency[include]=EUR&language[enabled]=true&language[include]=en&country[enabled]=true",
          function (lang) {
            //console.log(lang);
            writeNewArray(lang.detected_values.country["handle"]);
          }
        )
        .fail(function () {
          console.log("Error JSON call");
          writeNewArray(localStorage.getItem("lang-code"));
        });
  
      for (i = 0; i < numberOfClubs; i++) {
        HTML +=
          '<div class="club-wrapper"><img class="club-image" style="opacity: 0;" src="" alt=""><div class="club-name"></div></div>';
      }
  
      $("main .shopify-section:nth-child(" + sectionIndex + ") .SectionHeader").append(
        preHTML + HTML + posHTML
      );
      $("main .shopify-section:nth-child(" + sectionIndex + ") .SectionHeader .trusted-by").css({
        opacity: opacity,
      });
  
      function animateOut() {
        $(".club-image").css({
          opacity: 0,
          top: top,
        });
        $(".club-name").css({
          opacity: 0,
          top: top,
        });
      }
  
      function animateIn() {
        $(".club-image").each(function (i) {
          $(this).animate(
            {
              opacity: opacity,
              top: "0px",
            },
            (i + 1) * clubDelay,
            "swing"
          );
        });
        $(".club-name").each(function (i) {
          $(this).animate(
            {
              opacity: opacity,
              top: "0px",
            },
            ((i + 1) * (clubDelay * 1.5), "swing")
          );
        });
      }
  
      function changeClub(index) {
        var selectorBuilder =
          "main .shopify-section:nth-child(" + sectionIndex + ") .SectionHeader .big-wrapper .club-big-wrapper .club-wrapper:nth-child(" +
          (index + 1) +
          ") .club-image";
        $(selectorBuilder).attr(
          "src",
          linkPrefix + newLogosArray[logosArrayIndex][2] + linkSuffix
        );
        $(selectorBuilder).attr("alt", newLogosArray[logosArrayIndex][3]);
  
        var selectorBuilder2 =
          "main .shopify-section:nth-child(" + sectionIndex + ") .SectionHeader .big-wrapper .club-big-wrapper .club-wrapper:nth-child(" +
          (index + 1) +
          ") .club-name";
        $(selectorBuilder2).html(newLogosArray[logosArrayIndex][3]);
      }
  
      function rotate(reverse, time, force) {
        if (
          ($(
            "main .shopify-section:nth-child(" + sectionIndex + ") .SectionHeader .big-wrapper"
          ).hasClass("pauseInterval") == false &&
            notClicked) ||
          force
        ) {
          animateOut();
          setTimeout(function () {
            if (reverse) {
              logosArrayIndex -= numberOfClubs * 2;
              if (logosArrayIndex < 0) {
                logosArrayIndex += newLogosArray.length;
              }
            }
            for (i = 0; i < numberOfClubs; i++) {
              if (logosArrayIndex < newLogosArray.length) {
                changeClub(i);
                logosArrayIndex++;
              } else {
                logosArrayIndex = 0;
                changeClub(i);
                logosArrayIndex++;
              }
            }
          }, time);
          setTimeout(function () {
            animateIn();
          }, time);
        }
      }
  
      setTimeout(function () {
        rotate(false, clubDelay, false);
        setInterval(function () {
          rotate(false, clubDelay, false);
        }, refreshInterval);
      }, initialDelay);
  
      $("main .shopify-section:nth-child(" + sectionIndex + ") .SectionHeader .big-wrapper").hover(
        function () {
          $(this).addClass("pauseInterval");
        },
        function () {
          $(this)
            .delay(refreshInterval / 2)
            .removeClass("pauseInterval");
        }
      );
  
      $(".big-wrapper-arrow-left, .big-wrapper-arrow-right").on(
        "click",
        function () {
          notClicked = false;
          if ($(this).hasClass("big-wrapper-arrow-left")) {
            rotate(true, 125, true);
          } else if ($(this).hasClass("big-wrapper-arrow-right")) {
            rotate(false, 125, true);
          }
        }
      );
  
      if ($(window).width() <= 640) {
        $(".club-big-wrapper").css({
          width: "-webkit-fill-available",
        });
      }
    }
  }
  // End homepage

  // Cart page ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (window.location.href.indexOf("cart") > -1) {
    
    // Função para mudar link do "Comprar produtos"
    if ($(".EmptyState__Action").length) {
      var cartLink = window.Shopify.routes.root + "collections";
      $(".EmptyState__Action").attr("href", cartLink);
    }

    // Desactivar/activar Express
    setInterval(function () {
      //$(".express-available").hide();
      $(".express-unavailable").hide();
    }, 100);

    // Protótipo de funções para Cart.
    jQuery.getJSON(window.Shopify.routes.root + "cart.js", function (cart) {
      console.log(cart);

      $("head").prepend(
        "<style>.New p {font-size: " +
          $(".CartItem__Title").eq(0).css("font-size") +
          ";} </style>"
      );

      var maxDay = 0;
      var contains = false;
      var finalDate = "";

      function getDateComposed(days) {
        var targetDate = new Date();
        var weekday = targetDate.getDay();
        targetDate.setDate(
          targetDate.getDate() +
            days +
            (weekday === 6 ? 2 : +!weekday) +
            Math.floor((days - 1 + (weekday % 6 || 1)) / 5) * 2
        );
        //targetDate.setDate(targetDate.getDate() + days);
        var dd = targetDate.getDate();
        //var mm = targetDate.getMonth() + 1; // 0 is January, so we must add 1
        var mm = targetDate.toLocaleString("en-US", {
          month: "short",
        });
        var yyyy = targetDate.getFullYear();
        var dateString = dd + "/" + mm + "/" + yyyy;
        return dateString;
      }

      function minTotalPrice(minPrice) {
        if (cart.total_price < minPrice * 100) {
          return false;
        }
        return true;
      }

      function getVariant(variant) {
        var variantObj = {
          index: null,
        };
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].id == variant) {
            variantObj = Object.assign({}, cart.items[i]);
            variantObj.index = i;
          }
        }
        return variantObj;
      }

      var addCartVariants = {
        items: [],
      };

      function addCart() {
        if (addCartVariants.items.length) {
          /*fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(addCartVariants)
              })
              .then(response => {
                return response.json();
                console.log("Success");
                location.reload();
              })
              .catch((error) => {
                console.error('Error:', error);
              });*/
          jQuery.ajax({
            type: "POST",
            url: window.Shopify.routes.root + "cart/add.js",
            data: addCartVariants,
            dataType: "json",
            success: function () {
              location.reload();
            },
          });
        }
      }

      var changeCartVariants = {};

      function changeCart() {
        jQuery.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/change.js",
          data: changeCartVariants,
          dataType: "json",
          success: function () {
            location.reload();
          },
        });
      }

      var updateCartVariants = {};

      function updateCart() {
        jQuery.ajax({
          type: "POST",
          url: window.Shopify.routes.root + "cart/update.js",
          data: updateCartVariants,
          dataType: "json",
          success: function () {
            location.reload();
          },
        });
      }

      function hideCartElementQuantity(index) {
        //console.log(index);
        setTimeout(function () {
          $(".CartItem__QuantitySelector .QuantitySelector")
            .eq(index * 2)
            .css("display", "none");
          $(".CartItem__QuantitySelector .QuantitySelector")
            .eq(index * 2 + 1)
            .css("display", "none");
        }, 100);
      }

      // Função para autopromoções
      (function LivroJoelRocha() {
        var active = false;
        if (active) {
          var id = 46344494842194;
          var variant = getVariant(id);
          var minPrice = 89;
          var desiredQuantity = 1;
          if (minTotalPrice(minPrice) && variant.quantity == null) {
            console.log("Adicionar 1 unidade do livro ao carrinho");
            addCartVariants.items.push({
              quantity: desiredQuantity,
              id: id,
            });
            addCart();
          } else if (
            minTotalPrice(minPrice) == false &&
            variant.quantity >= desiredQuantity
          ) {
            console.log("Remover livro ao carrinho");
            changeCartVariants = {
              quantity: 0,
              id: id,
            };
            changeCart();
          } else if (variant.quantity > desiredQuantity) {
            console.log("Actualizar quantidade do livro para 1 unidade");
            changeCartVariants = {
              quantity: desiredQuantity,
              id: id,
            };
            changeCart();
          } else if (variant.quantity == desiredQuantity) {
            hideCartElementQuantity(variant.index);
          }
        }
      })();

      // Obter e mostrar global ETA
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].properties != null) {
          if (
            cart.items[i].properties.hasOwnProperty("_Estimaded Manufacturing")
          ) {
            var number = Number(
              cart.items[i].properties["_Estimaded Manufacturing"]
                .split(" ")
                .shift()
            );
            if (number > maxDay) {
              maxDay = number;
            }
          }
        }
      }
      var finalDateNormal = getDateComposed(maxDay);
      finalDate = finalDateNormal;
      setTimeout(function () {
        $("#globalETA").html(maxDay);
        $("#globalETAfast").html(Math.ceil(maxDay / 3));
      }, 800);
      updateCartVariants = {
        attributes: {
          "Limit manufacturing date": finalDateNormal,
        },
      };

      // Função caso haja "Express Manufactoring" no carrinho
      var id = 39814845890642;
      var variant = getVariant(id);
      if (variant.quantity > 0) {
        // Replace Limit factoring time
        var finalDateFaste = getDateComposed(Math.round(maxDay / 1.75));
        // var finalDateFaste = getDateComposed(Math.round(maxDay / 3));
        finalDate = finalDateFaste;
        updateCartVariants.attributes["Limit manufacturing date"] =
          finalDateFaste;

        // Função para mostrar butão como "Selected"
        hideCartElementQuantity(variant.index);
        setTimeout(function () {
          $("a#addPriority").html(" (Added to cart)");
          $("a#addPriority").css("cursor", "initial");
          $("a#addPriority").removeAttr("onclick");
          $("#globalETAfastPrice").hide();
        }, 500);
      }
      if (cart.attributes["Limit manufacturing date"] !== finalDate) {
        updateCart();
      }

      // Função upselling e cross-selling

      // Função para bloquear encomenda com mais de 30kg
      setTimeout(function () {
        $("#globalKG").html(
          Math.round(cart.total_weight * 0.01) / 10 + " kg (max. 30 kg)"
        );
        if (cart.total_weight >= 30000) {
          $("#globalKG").css("color", "#ff0000");
        }
      }, 500);

      // Função para properties of Spiff
      setTimeout(function () {
        $('body').append(`
          <div id="spiffModal" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:white; z-index:100000000;">
            <img id="spiffModalImage" src="" style="max-width:100%; max-height:100%; margin:auto; position:absolute; top:0; left:0; bottom:0; right:0;">
            <button id="spiffModalClose" style="font-size: 20px;background-color: #f0f0f0;padding: 10px 20px 12px;border-radius: 100px;position: absolute;top: 19px;right: 20px;">✕</button>
          </div>`);
        $('#spiffModalClose, #spiffModal').click(function() {
            $('#spiffModal').hide();
        });
        $(".CartItem__Property").each(function() {
          var $this = $(this);
          var text = $this.text();
          if (text.includes('spiffTransactionId: ') || text.includes('previewImage: ')) {
            $this.hide();
            if (text.includes('previewImage: ')) {
              var imgUrl = text.replace('previewImage: ', '');
              $this.closest(".CartItem__Info").siblings(".CartItem__ImageWrapper").find(".CartItem__Image").attr("src", imgUrl);
            }
          }
          if (text.includes('file: ') || text.includes('3d: ')) {
            $this.hide();
          }
          if ($this.siblings(':contains("spiff"), :contains("previewImage")').length > 0) {
            var colonPos = text.indexOf(':');
            var lastSpacePos = text.lastIndexOf(' ', colonPos);
            if (lastSpacePos !== -1) {
              var newText = text.substring(0, lastSpacePos) + text.substring(colonPos);
              $this.text(newText);
            }
          }
          if (text.includes('assets.spiff.com.au')) {
            var url = text.split(': ')[1];
            var span = `<span style="color:#0066ff; text-decoration:underline; cursor:pointer;" onclick="$('#spiffModalImage').attr('src', '${url}'); $('#spiffModal').show();">View</span>`;
            $(this).html(text.split(': ')[0].replace("image", ": ") + span);
          }
        });
      }, 500);
      

      
    });
  }
  // End cart page

  // Product pages ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (window.location.href.indexOf("products") > -1) {

    // Substituir ' / ' por nova linha
    $(".containerCountDown").each(function (i) {
      var value = " / ";
      if ($(this).html().includes(value)) {
        var text = $(this).html();
        text = text.replaceAll(value, "<br>");
        $(this).html(text);
      }
    });
    
    // Function prototype to revert child order
    $.fn.reverseChildren = function () {
      return this.each(function () {
        var $this = $(this);
        $this.children().each(function () {
          $this.prepend(this);
        });
      });
    };

    // Mover e mostrar infiniteoptions-container
    if ($('[onclick^="customizeWithoutCustomilyOpen()').length) {
      console.log($("#infiniteoptions-container"));
      setTimeout(function () {
        $("#infiniteoptions-container").css("display", "block");
        $("#infiniteoptions-container")
          .detach()
          .appendTo($("#customization_simple"));
        $("#customization_simpleClose")
          .detach()
          .appendTo($("#customization_simple"));
      }, 1000);
    }
    

    // Mover navegação das imagens de produto para cima de "ver no meu esapço"
    $(".Product__ViewInSpace").detach().appendTo($(".Product__Gallery"));

    // Abrir e fechar menu de personalização antigo
    $(".ProductForm > .Form__Item").css("margin-bottom", "0");
    $(".ProductForm > .Form__Item .Alert").css("margin-bottom", "0");
    if ($('[onclick^="customizeWithoutCustomilyOpen()').length) {
      $("#customization_simple").css("padding-bottom", "0");
      $("#customization_simpleClose").css("margin-bottom", "0");
      $("#customization_simple .Form__Alert").removeClass("Alert--error");
      $("#customization_simple .Form__Alert").css(
        "background-color",
        "#f5f5f5"
      );
      $("#customization_simple").hide();
      $(".ProductForm__Variants").wrap("<div class='new_group'></div>");
      $('[onclick^="customizeWithoutCustomilyOpen()')
        .detach()
        .appendTo($(".new_group"));
      $(".ProductForm__AddToCart").detach().appendTo($(".new_group"));
      $(".ProductForm > .Form__Item").detach().appendTo($(".new_group"));
      $("#customization_simple").detach().appendTo($(".ProductForm"));
      var animation_time = 500;
      var title_top = 0;
      $('.Container div[onclick^="customizeWithoutCustomilyOpen()').click(
        function () {
          //window.scroll({top: title_top, behavior: 'smooth'});
          $(".ProductForm__Variants").css("margin-bottom", "0px");
          $(".new_group").slideUp(animation_time);
          $(".ProductMeta__Description").slideUp(animation_time);
          $("#customization_simple")
            .delay(animation_time)
            .slideDown(animation_time);
        }
      );
      $('.Container div[onclick^="customizeWithoutCustomilyClose()').click(
        function () {
          //window.scroll({top: title_top, behavior: 'smooth'});
          $(".ProductForm__Variants").css("margin-bottom", "25px");
          $("#customization_simple").slideUp(animation_time);
          $(".ProductMeta__Description")
            .delay(animation_time)
            .slideDown(animation_time);
          $(".new_group").delay(animation_time).slideDown(animation_time);
        }
      );
    }

    // Menu de personalização novo

    /*
      DEVELOPMENT ROADMAP:
       - Solve problem with horizontal scrolling steps after many clicks
       - Cross sell step
       - Validation on final step
       - Compare customization
       - Combine customization
       - Locale translation
       - Get image url for cross-sell products
       - Add cross-sell products to cart after main product through Local.storage
       - Edit customization in cart
       - Customization presets
       - Save customizations for later, use previous customizations
       - Share customizations through URL
       - Develop a page for internal use that allows a input of a customation id and the customization is populated
       - Develop a function that saves current viewport into a pdf with the s
     */

    if ($("#CustomizationPopup").length) {
      function loadScript(url) {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      async function initScript() {
        try {
          await Promise.all([
            loadScript(
              "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.4.0/jspdf.umd.min.js"
            ),
            loadScript(
              "https://html2canvas.hertzen.com/dist/html2canvas.min.js"
            ),
            loadScript("https://unpkg.com/pdf-lib/dist/pdf-lib.min.js"),
          ]);
          document
            .getElementById("download-pdf")
            .addEventListener("click", async () => {
              showLoadingMessage();
              await createPdf();
              hideLoadingMessage();
            });
        } catch (error) {
          console.error(error);
        }
      }
      initScript();

      let currentStep = 0;
      const customizationAnimationDuration = 500;
      var currentSKU = null;
      var savedSku = null;
      var savedCustomization = null;
      var customization = null;

      function refreshSKU() {
        setTimeout(function () {
          currentSKU = $(".ProductMeta__SkuNumber").text();
          $("#CustomizationPopup").attr("sku", currentSKU);
        }, 10);
      }
      refreshSKU();

      document.addEventListener("variant:changed", function (event) {
        refreshSKU();
      });

      function stepsWidth() {
        $(".CustomizationPopupStep").each(function () {
          $(this).css("width", $("#CustomizationPopupInner").css("width"));
        });
      }

      function showLoadingMessage() {
        const loadingMessage = document.getElementById("loading-message");
        loadingMessage.style.display = "block";
      }

      function hideLoadingMessage() {
        const loadingMessage = document.getElementById("loading-message");
        loadingMessage.style.display = "none";
      }

      async function preloadBackgroundImages(elements) {
        const getImageURL = (element) => {
          const style = getComputedStyle(element);
          const url = style.backgroundImage.slice(4, -1).replace(/['"]/g, "");
          return url;
        };
        const loadImage = (url) => {
          return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = url;
            image.onload = () => resolve(image);
            image.onerror = () =>
              reject(new Error(`Failed to load image: ${url}`));
          });
        };
        const promises = [];
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          const imageURL = getImageURL(element);
          if (imageURL && imageURL !== "none") {
            promises.push(loadImage(imageURL));
          }
          const imgElements = element.querySelectorAll("img");
          for (let j = 0; j < imgElements.length; j++) {
            const img = imgElements[j];
            if (img.src) {
              promises.push(loadImage(img.src));
            }
          }
        }
        await Promise.all(promises);
      }

      async function createPdf() {
        const elements = document.querySelectorAll("#CustomizationPopupInner");
        await preloadBackgroundImages(elements);
        const DPI = 300;
        const PIXELS_PER_MM = DPI / 25.4;
        const { PDFDocument } = PDFLib;
        const mergedPdf = await PDFDocument.create();
        const mergePages = async (sourceBytes) => {
          const sourcePdfDoc = await PDFDocument.load(sourceBytes);
          const pageCount = sourcePdfDoc.getPageCount();
          for (let i = 0; i < pageCount; i++) {
            const [page] = await mergedPdf.copyPages(sourcePdfDoc, [i]);
            mergedPdf.addPage(page);
          }
        };
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          const elementWidthPx = element.offsetWidth;
          const elementHeightPx = element.offsetHeight;
          const elementWidthMm = elementWidthPx / PIXELS_PER_MM;
          const elementHeightMm = elementHeightPx / PIXELS_PER_MM;

          // Create a new jsPDF instance for each element with the corresponding dimensions
          const doc = new window.jspdf.jsPDF({
            orientation:
              elementWidthMm > elementHeightMm ? "landscape" : "portrait",
            unit: "mm",
            format: [elementWidthMm, elementHeightMm],
          });

          // Render the element on the canvas with a higher resolution
          const canvas = await html2canvas(element, {
            scale: DPI / 96,
          });

          // Add the element image to the PDF
          const imageData = canvas.toDataURL("image/png");
          const imageBytes = Uint8Array.from(
            atob(imageData.split(",")[1]),
            (c) => c.charCodeAt(0)
          );
          const image = await PDFDocument.createImage(imageBytes);
          const page = mergedPdf.addPage([elementWidthMm, elementHeightMm]);
          page.drawImage(image, {
            x: 0,
            y: 0,
            width: elementWidthMm,
            height: elementHeightMm,
          });
          // Merge the current jsPDF instance with the previous one
          await mergePages(doc.output("arraybuffer"));
        }
        // Serialize the merged PDF and save it
        const mergedPdfBytes = await mergedPdf.save();
        const blob = new Blob([mergedPdfBytes], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "my-file.pdf";
        link.click();
      }

      var customizationOptions = {
        sports: [
          "DoNotTranslateSports",
          "Soccer",
          "Futsal",
          "Basketball",
          "RinkHockey",
          "Volleyball",
          "Handball",
          "Rugby",
          "BeachSoccer",
        ],
        titles: {
          pc: "Pitch configurations",
          co: "Colors",
          ma: "Magnets",
          te: "Texts",
          im: "Images",
          ex: "Extras",
          wa: "Warning",
        },
        clone: {
          id: "_C",
          class: "blockHidden",
          name: "(custom)",
          descritive:
            "Describe your vision here and our team will design it accordingly.",
          placeholder: "I pretend a writing zone bellow 2 full pitches",
        },
        blocks: [
          {
            id: ["PC_F", "PC_B", "PC_L", "PC_R"],
            name: ["Front side", "Back side", "Left side", "Right side"],
            descritive: [
              "Descritive text explaining this field",
              "Descritive text explaining this field",
              "Descritive text explaining this field",
              "Descritive text explaining this field",
            ],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [true],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "FP1",
                  name: "1 Full pitch",
                },
                {
                  id: "FP2",
                  name: "2 Full pitches",
                },
                {
                  id: "FP4",
                  name: "4 Full pitches",
                },
                {
                  id: "HP1",
                  name: "1 Half pitch",
                },
                {
                  id: "HP2",
                  name: "2 Half pitches",
                },
                {
                  id: "HP4",
                  name: "4 Half pitches",
                },
                {
                  id: "HP1WZ",
                  name: "1 Half pitch + Writing zone",
                },
                {
                  id: "HP2WZ",
                  name: "2 Half pitches + Writing zone",
                },
                {
                  id: "-",
                  name: null,
                },
              ],
            ],
          },
          {
            id: ["PC_P"],
            name: ["Board configuration"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            custom: [true],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "FP1",
                  name: "1 Full pitch",
                },
                {
                  id: "-",
                  name: null,
                },
              ],
            ],
          },
          {
            id: ["PC_AM"],
            name: ["Additional marks"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [true],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "-",
                  name: "None",
                },
                {
                  id: "3C",
                  name: "3 Corridors",
                },
                {
                  id: "6C",
                  name: "6 Corridors",
                },
                {
                  id: "3S",
                  name: "3 Sectors",
                },
                {
                  id: "6S",
                  name: "6 Sectors",
                },
                {
                  id: "3C3S",
                  name: "3 Corridors + 3 Sectors",
                },
                {
                  id: "3C6S",
                  name: "3 Corridors + 6 Sectors",
                },
                {
                  id: "6C3S",
                  name: "6 Corridors + 3 Sectors",
                },
                {
                  id: "6C6S",
                  name: "6 Corridors + 6 Sectors",
                },
                {
                  id: "-",
                  name: null,
                },
              ],
            ],
          },
          {
            id: ["PC_AN"],
            name: ["Additional notations"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [true],
            type: "select",
            sports: null,
            options: null,
          },
          {
            id: ["C_T"],
            name: ["Pitch texture"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "PL",
                  name: "Plain",
                },
                {
                  id: "GR",
                  name: "Grass",
                },
                {
                  id: "GS",
                  name: "Grass striped",
                },
                {
                  id: "GC",
                  name: "Grass chess",
                },
                {
                  id: "PV",
                  name: "Parquet",
                },
                {
                  id: "PT",
                  name: "Parquet 2",
                },
                {
                  id: "SA",
                  name: "Sand",
                },
              ],
            ],
          },
          {
            id: ["C_P", "C_N"],
            name: ["Pitch color", "Accent color"],
            descritive: [
              "Descritive text explaining this field",
              "Descritive text explaining this field",
            ],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "WH",
                  name: "White",
                },
                {
                  id: "BE",
                  name: "Beije",
                },
                {
                  id: "YE",
                  name: "Yellow",
                },
                {
                  id: "OR",
                  name: "Orange",
                },
                {
                  id: "RE",
                  name: "Red",
                },
                {
                  id: "PI",
                  name: "Pink",
                },
                {
                  id: "PU",
                  name: "Purple",
                },
                {
                  id: "DB",
                  name: "Dark blue",
                },
                {
                  id: "LB",
                  name: "Light blue",
                },
                {
                  id: "TU",
                  name: "Turquoise",
                },
                {
                  id: "LG",
                  name: "Light green",
                },
                {
                  id: "DG",
                  name: "Dark green",
                },
                {
                  id: "BL",
                  name: "Black",
                },
                {
                  id: "GR",
                  name: "Gray",
                },
              ],
            ],
          },
          {
            id: ["C_B"],
            name: ["Background color"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "WH",
                  name: "White",
                },
                {
                  id: "BL",
                  name: "Black",
                },
              ],
            ],
          },
          {
            id: ["C_F", "C_M", "C_A"],
            name: ["Frame color", "Midpitch color", "Areas color"],
            descritive: [
              "Descritive text explaining this field",
              "Descritive text explaining this field",
              "Descritive text explaining this field",
            ],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "select",
            sports: [["Futsal", "Basketball", "RinkHockey", "Handball"]],
            options: [
              [
                {
                  id: "WH",
                  name: "White",
                },
                {
                  id: "BE",
                  name: "Beije",
                },
                {
                  id: "YE",
                  name: "Yellow",
                },
                {
                  id: "OR",
                  name: "Orange",
                },
                {
                  id: "RE",
                  name: "Red",
                },
                {
                  id: "PI",
                  name: "Pink",
                },
                {
                  id: "PU",
                  name: "Purple",
                },
                {
                  id: "DB",
                  name: "Dark blue",
                },
                {
                  id: "LB",
                  name: "Light blue",
                },
                {
                  id: "TU",
                  name: "Turquoise",
                },
                {
                  id: "LG",
                  name: "Light green",
                },
                {
                  id: "DG",
                  name: "Dark green",
                },
                {
                  id: "BL",
                  name: "Black",
                },
                {
                  id: "GR",
                  name: "Gray",
                },
              ],
            ],
          },
          {
            id: ["M_QT_TA", "M_QT_TB", "M_QT_GA", "M_QT_GB"],
            name: [
              "Magnets team A",
              "Magnets team B",
              "Magnets goalkeeper A",
              "Magnets goalkeeper B",
            ],
            descritive: [
              "Descritive text explaining this field",
              "Descritive text explaining this field",
              "Descritive text explaining this field",
              "Descritive text explaining this field",
            ],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "select",
            sports: null,
            options: [
              [
                {
                  id: "BL",
                  name: "Black",
                },
                {
                  id: "WH",
                  name: "White",
                },
                {
                  id: "YE",
                  name: "Yellow",
                },
                {
                  id: "OR",
                  name: "Orange",
                },
                {
                  id: "RE",
                  name: "Red",
                },
                {
                  id: "DB",
                  name: "Dark blue",
                },
                {
                  id: "LB",
                  name: "Light blue",
                },
                {
                  id: "DG",
                  name: "Dark green",
                },
                {
                  id: "LG",
                  name: "Light green",
                },
              ],
            ],
          },
          {
            id: ["M_QP"],
            name: ["Magnets planning"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "select",
            sports: null,
            options: [
              {
                id: "BL",
                name: "Black",
              },
            ],
          },
          {
            id: ["T_N", "T_S", "T_P"],
            name: ["Coach name", "Coach Position", "Phrase"],
            descritive: [
              "Descritive text explaining this field",
              "Descritive text explaining this field",
              "Descritive text explaining this field",
            ],
            placeholder: ["John Smith", "Head Coach", "For Successful Coaches"],
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: false,
            customProperty: [false],
            type: "text",
            sports: null,
            options: null,
          },
          {
            id: ["I_L", "I_P"],
            name: ["Club logo", "Coach photo"],
            descritive: [
              "Descritive text explaining this field",
              "Descritive text explaining this field",
            ],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: false,
            customProperty: [false],
            type: "image",
            sports: null,
            options: null,
          },
          {
            id: ["CS_NB_T_Soccer", "CS_NB_T_Futsal"],
            name: ["Extra training notebook"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "cross_sale",
            sports: [["Soccer"], ["Futsal"]],
            options: [
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 39798580674642,
                  name: "1 units (+10€)",
                },
                {
                  id: 39982055817298,
                  name: "3 units (+19€) (2 + 1 free)",
                },
                {
                  id: 39982055850066,
                  name: "5 units (+29€) (3 + 2 free)",
                },
                {
                  id: 40135195787346,
                  name: "10 units (+49€) (5 + 5 free)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 39798578511954,
                  name: "1 units (+10€)",
                },
                {
                  id: 39982067810386,
                  name: "3 units (+19€) (2 + 1 free)",
                },
                {
                  id: 39982067843154,
                  name: "5 units (+29€) (3 + 2 free)",
                },
                {
                  id: 40135204012114,
                  name: "10 units (+49€) (5 + 5 free)",
                },
              ],
            ],
          },
          {
            id: ["CS_NB_M_Soccer", "CS_NB_M_Futsal"],
            name: ["Extra match notebook"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "cross_sale",
            sports: [["Soccer"], ["Futsal"]],
            options: [
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 40195390963794,
                  name: "1 units (+10€)",
                },
                {
                  id: 40195390996562,
                  name: "3 units (+19€) (2 + 1 free)",
                },
                {
                  id: 40195391029330,
                  name: "5 units (+29€) (3 + 2 free)",
                },
                {
                  id: 40195391062098,
                  name: "10 units (+49€) (5 + 5 free)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 40195390832722,
                  name: "1 units (+10€)",
                },
                {
                  id: 40195390865490,
                  name: "3 units (+19€) (2 + 1 free)",
                },
                {
                  id: 40195390898258,
                  name: "5 units (+29€) (3 + 2 free)",
                },
                {
                  id: 40195390931026,
                  name: "10 units (+49€) (5 + 5 free)",
                },
              ],
            ],
          },
          {
            id: ["CS_P"],
            name: ["Extra pens"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "cross_sale",
            conditions: null,
            options: [
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 39772694839378,
                  name: "3 units (+10€)",
                },
                {
                  id: 39772694872146,
                  name: "5 units (+15€) (-10% discount)",
                },
                {
                  id: 39772694904914,
                  name: "10 units (+25€) (-25% discount)",
                },
                {
                  id: 40142883160146,
                  name: "20 units (+35€) (-45% discount)",
                },
              ],
            ],
          },
          {
            id: [
              "CS_MA_IQ_Soccer",
              "CS_MA_IQ_Futsal",
              "CS_MA_IQ_Basketball",
              "CS_MA_IQ_RinkHockey",
              "CS_MA_IQ_Handball",
              "CS_MA_IQ_Volleyball",
              "CS_MA_IQ_BeachSoccer",
              "CS_MA_IQ_Rugby",
              "CS_MA_IB_Soccer",
              "CS_MA_IB_Futsal",
              "CS_MA_IB_Basketball",
              "CS_MA_IB_RinkHockey",
              "CS_MA_IB_Handball",
              "CS_MA_IB_Volleyball",
              "CS_MA_IB_BeachSoccer",
              "CS_MA_IB_Rugby",
            ],
            name: ["Extra magnets"],
            descritive: ["Descritive text explaining this field"],
            placeholder: null,
            image: [
              "https://cdn.shopify.com/s/files/1/2171/2773/products/Rugbywhite_1723c607-8cf0-403b-a817-63839e6e56e6_800x.jpg?v=1591055532",
            ],
            required: true,
            customProperty: [false],
            type: "cross_sale",
            sports: [
              ["Soccer"],
              ["Futsal"],
              ["Basketball"],
              ["RinkHockey"],
              ["Handball"],
              ["Volleyball"],
              ["BeachSoccer"],
              ["Rugby"],
              ["Soccer"],
              ["Futsal"],
              ["Basketball"],
              ["RinkHockey"],
              ["Handball"],
              ["Volleyball"],
              ["BeachSoccer"],
              ["Rugby"],
            ],
            options: [
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450835538,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585151570,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585184338,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450868306,
                  name: "1 pack (+10€)",
                },
                {
                  id: 39854585086034,
                  name: "2 packs (+15€) (-10% discount)",
                },
                {
                  id: 39854585118802,
                  name: "3 packs (+20€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450901074,
                  name: "1 pack (+10€)",
                },
                {
                  id: 39854585217106,
                  name: "2 packs (+15€) (-10% discount)",
                },
                {
                  id: 39854585249874,
                  name: "3 packs (+20€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450966610,
                  name: "1 pack (+10€)",
                },
                {
                  id: 39854585282642,
                  name: "2 packs (+15€) (-10% discount)",
                },
                {
                  id: 39854585315410,
                  name: "3 packs (+20€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450999378,
                  name: "1 pack (+10€)",
                },
                {
                  id: 39854585348178,
                  name: "2 packs (+15€) (-10% discount)",
                },
                {
                  id: 39854585380946,
                  name: "3 packs (+20€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450933842,
                  name: "1 pack (+10€)",
                },
                {
                  id: 39854585413714,
                  name: "2 packs (+15€) (-10% discount)",
                },
                {
                  id: 39854585446482,
                  name: "3 packs (+20€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846451097682,
                  name: "1 pack (+10€)",
                },
                {
                  id: 39854585479250,
                  name: "2 packs (+15€) (-10% discount)",
                },
                {
                  id: 39854585512018,
                  name: "3 packs (+20€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 32542072963154,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585544786,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585577554,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846421508178,
                  name: "1 pack (+25€)",
                },
                {
                  id: 39854585675858,
                  name: "2 packs (+30€) (-10% discount)",
                },
                {
                  id: 39854585708626,
                  name: "3 packs (+35€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450540626,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585610322,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585643090,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450573394,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585741394,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585774162,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450638930,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585806930,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585839698,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450671698,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585872466,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585905234,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450606162,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854585938002,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854585970770,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 12846450770002,
                  name: "1 pack (+15€)",
                },
                {
                  id: 39854586003538,
                  name: "2 packs (+20€) (-10% discount)",
                },
                {
                  id: 39854586036306,
                  name: "3 packs (+25€) (-25% discount)",
                },
              ],
              [
                {
                  id: 0,
                  name: "None",
                },
                {
                  id: 32542073389138,
                  name: "1 pack (+25€)",
                },
                {
                  id: 39854586069074,
                  name: "2 packs (+30€) (-10% discount)",
                },
                {
                  id: 39854586101842,
                  name: "3 packs (+35€) (-25% discount)",
                },
              ],
            ],
          },
        ],
      };

      function getOptions() {
        console.log("Get options");
        var options;
        switch (customization.sku.model) {
          case "CT":
            options = [
              ["PC_L"],
              ["PC_R"],
              ["PC_AM"],
              ["C_B"],
              ["C_T"],
              ["C_P"],
              ["C_N"],
              ["C_F"],
              ["C_M"],
              ["C_A"],
              ["M_QT_TA", "M_QT_GA"],
              ["M_QT_TB", "M_QT_GB"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_NB_T_Soccer"],
              ["CS_NB_T_Futsal"],
              ["CS_NB_M_Soccer"],
              ["CS_NB_M_Futsal"],
              ["CS_MA_IQ_Soccer"],
              ["CS_MA_IQ_Futsal"],
              ["CS_MA_IQ_Basketball"],
              ["CS_MA_IQ_RinkHockey"],
              ["CS_MA_IQ_Handball"],
              ["CS_MA_IQ_Volleyball"],
              ["CS_MA_IQ_BeachSoccer"],
              ["CS_MA_IQ_Rugby"],
              ["CS_P"],
            ];
            break;
          case "CB":
            options = [
              ["PC_F"],
              ["PC_B"],
              ["PC_AM"],
              ["C_B"],
              ["C_T"],
              ["C_P"],
              ["C_N"],
              ["C_F"],
              ["C_M"],
              ["C_A"],
              ["M_QT_TA", "M_QT_GA"],
              ["M_QT_TB", "M_QT_GB"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_NB_T_Soccer"],
              ["CS_NB_T_Futsal"],
              ["CS_NB_M_Soccer"],
              ["CS_NB_M_Futsal"],
              ["CS_MA_IQ_Soccer"],
              ["CS_MA_IQ_Futsal"],
              ["CS_MA_IQ_Basketball"],
              ["CS_MA_IQ_RinkHockey"],
              ["CS_MA_IQ_Handball"],
              ["CS_MA_IQ_Volleyball"],
              ["CS_MA_IQ_BeachSoccer"],
              ["CS_MA_IQ_Rugby"],
              ["CS_P"],
            ];
            break;
          case "QBDS":
          case "WB":
            options = [
              ["PC_F"],
              ["PC_B"],
              ["PC_AM"],
              ["C_B"],
              ["C_T"],
              ["C_P"],
              ["C_N"],
              ["C_F"],
              ["C_M"],
              ["C_A"],
              ["M_QT_TA", "M_QT_GA"],
              ["M_QT_TB", "M_QT_GB"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_NB_T_Soccer"],
              ["CS_NB_T_Futsal"],
              ["CS_NB_M_Soccer"],
              ["CS_NB_M_Futsal"],
              ["CS_MA_IB_Soccer"],
              ["CS_MA_IB_Futsal"],
              ["CS_MA_IB_Basketball"],
              ["CS_MA_IB_RinkHockey"],
              ["CS_MA_IB_Handball"],
              ["CS_MA_IB_Volleyball"],
              ["CS_MA_IB_BeachSoccer"],
              ["CS_MA_IB_Rugby"],
              ["CS_P"],
            ];
            break;
          case "LB":
            options = [
              ["PC_F"],
              ["PC_B"],
              ["PC_AM"],
              ["C_B"],
              ["C_T"],
              ["C_P"],
              ["C_N"],
              ["C_F"],
              ["C_M"],
              ["C_A"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_NB_T_Soccer"],
              ["CS_NB_T_Futsal"],
              ["CS_NB_M_Soccer"],
              ["CS_NB_M_Futsal"],
              ["CS_P"],
            ];
            break;
          case "SB":
            options = [
              ["PC_F"],
              ["PC_AM"],
              ["C_B"],
              ["C_T"],
              ["C_P"],
              ["C_N"],
              ["C_F"],
              ["C_M"],
              ["C_A"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_NB_T_Soccer"],
              ["CS_NB_T_Futsal"],
              ["CS_NB_M_Soccer"],
              ["CS_NB_M_Futsal"],
              ["CS_P"],
            ];
            break;
          case "QB":
          case "FC":
          case "FCR":
            options = [
              ["PC_F"],
              ["PC_AM"],
              ["C_B"],
              ["C_T"],
              ["C_P"],
              ["C_N"],
              ["C_F"],
              ["C_M"],
              ["C_A"],
              ["M_QT_TA", "M_QT_GA"],
              ["M_QT_TB", "M_QT_GB"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_NB_T_Soccer"],
              ["CS_NB_T_Futsal"],
              ["CS_NB_M_Soccer"],
              ["CS_NB_M_Futsal"],
              ["CS_MA_IB_Soccer"],
              ["CS_MA_IB_Futsal"],
              ["CS_MA_IB_Basketball"],
              ["CS_MA_IB_RinkHockey"],
              ["CS_MA_IB_Handball"],
              ["CS_MA_IB_Volleyball"],
              ["CS_MA_IB_BeachSoccer"],
              ["CS_MA_IB_Rugby"],
              ["CS_P"],
            ];
            break;
          case "QP":
            options = [
              ["PC_P"],
              ["C_B"],
              ["M_QP"],
              ["T_N"],
              ["T_S"],
              ["T_P"],
              ["I_L"],
              ["I_P"],
              ["CS_MP"],
              ["CS_P"],
            ];
            break;
          case "BN":
            options = [["C_N"], ["T_N"], ["I_L"]];
            break;
          case "IQT":
          case "IQB":
            options = [
              ["M_QT_TA", "M_QT_GA"],
              ["M_QT_TB", "M_QT_GB"],
            ];
            break;
          case "IQP":
            options = [["M_QP"]];
            break;
        }
        return options;
      }

      function renderSteps() {
        console.log("Render steps");
        const container = document.createElement("div");
        customization.steps.forEach((step) => {
          const stepElem = document.createElement("div");
          stepElem.classList.add("CustomizationPopupStep");
          const titleElem = document.createElement("div");
          titleElem.classList.add(
            "CustomizationPopupStepTitle",
            "Heading",
            "u-h3"
          );
          titleElem.textContent = step.title;
          const imgElem = document.createElement("img");
          imgElem.classList.add("CustomizationPopupStepImage");
          imgElem.setAttribute("src", step.image);
          stepElem.appendChild(titleElem);
          stepElem.appendChild(imgElem);
          step.blocks.forEach((block) => {
            const blockElem = document.createElement("div");
            blockElem.innerHTML = block.html;
            stepElem.appendChild(blockElem);
          });
          container.appendChild(stepElem);
        });
        customization.html = container.innerHTML;
      }

      function getProperties(i, property) {
        return property.length > 1 ? property[i] : property[0];
      }

      function renderBlock(id, isClone) {
        console.log("Render block: " + id + " (" + isClone + ")");
        for (const blockOption of customizationOptions.blocks) {
          const index = blockOption.id.findIndex(
            (elementId) => elementId === id
          );
          if (index !== -1) {
            const sports = blockOption.sports
              ? getProperties(index, blockOption.sports)
              : customizationOptions.sports;
            const validatedSports = sports.includes(customization.sku.sport);
            if (validatedSports) {
              const block = {
                id: isClone ? id + customizationOptions.clone.id : id,
                customProperty: !!getProperties(
                  index,
                  blockOption.customProperty
                ),
                name:
                  getProperties(index, blockOption.name) +
                  (isClone ? customizationOptions.clone.name : ""),
                image: getProperties(index, blockOption.image),
              };

              const container = document.createElement("div");
              container.classList.add("Form__Item");
              if (isClone) {
                container.classList.add(customizationOptions.clone.class);
              }

              const label = document.createElement("label");
              label.classList.add("CustomizationPopupStepBlockLabel");
              label.htmlFor =
                id + (isClone ? customizationOptions.clone.id : "");
              label.textContent = block.name;
              container.appendChild(label);

              const descritive = document.createElement("p");
              descritive.classList.add("CustomizationPopupStepBlockDescritive");
              descritive.textContent =
                getProperties(index, blockOption.descritive) +
                (isClone
                  ? ""
                  : blockOption.required
                  ? " (Required)"
                  : " (Optional)");
              container.appendChild(descritive);

              let inputElement;
              const commonAttributes = {
                class: "Form__Validate",
                ctype: blockOption.type,
                cname: block.name,
                cid: id,
              };

              if (isClone) {
                inputElement = document.createElement("textarea");
                Object.assign(inputElement, {
                  ...commonAttributes,
                  id: id + customizationOptions.clone.id,
                  name: `properties[${block.name}]`,
                  placeholder: customizationOptions.clone.placeholder,
                });
                inputElement.classList.add("Form__Validate");
              } else {
                switch (blockOption.type) {
                  case "select":
                    inputElement = document.createElement("select");
                    Object.assign(inputElement, {
                      ...commonAttributes,
                      id: id,
                      name: `properties[${block.name}]`,
                      validate: blockOption.required ? "required" : "optional",
                    });
                    inputElement.classList.add("Form__Validate");

                    const defaultOption = document.createElement("option");
                    defaultOption.selected = true;
                    defaultOption.disabled = true;
                    defaultOption.textContent = "Select an option";
                    inputElement.appendChild(defaultOption);

                    const options = getProperties(index, blockOption.options);
                    for (const option of options) {
                      const optionElement = document.createElement("option");
                      optionElement.value = option.name;
                      optionElement.textContent = option.name;
                      inputElement.appendChild(optionElement);
                    }
                    break;
                  case "text":
                  case "textarea":
                    inputElement = document.createElement(blockOption.type);
                    Object.assign(inputElement, {
                      ...commonAttributes,
                      id: id,
                      name: `properties[${block.name}]`,
                      type: "text",
                      placeholder: getProperties(
                        index,
                        blockOption.placeholder
                      ),
                    });
                    inputElement.classList.add("Form__Validate");
                    break;
                  case "image":
                    inputElement = document.createElement("input");
                    Object.assign(inputElement, {
                      ...commonAttributes,
                      id: id,
                      name: `properties[${block.name}]`,
                      type: "file",
                      accept: "image/*",
                    });
                    inputElement.classList.add("Form__Validate");
                    break;
                  case "cross_sale":
                    inputElement = document.createElement("ul");
                    inputElement.classList.add(
                      "SizeSwatchList",
                      "HorizontalList",
                      "HorizontalList--spacingTight"
                    );

                    const crossSale = getProperties(index, blockOption.options);
                    for (const option of crossSale) {
                      const li = document.createElement("li");
                      li.classList.add("HorizontalList__Item");

                      const input = document.createElement("input");
                      Object.assign(input, {
                        ...commonAttributes,
                        id: option.id,
                        type: "radio",
                        name: block.name,
                        value: option.id,
                      });
                      input.classList.add(
                        "Form__Validate",
                        "SizeSwatch__Radio"
                      );

                      const label = document.createElement("label");
                      label.htmlFor = option.id;
                      label.classList.add("SizeSwatch");
                      label.textContent = option.name;

                      li.appendChild(input);
                      li.appendChild(label);
                      inputElement.appendChild(li);
                    }
                    break;
                }
              }
              container.appendChild(inputElement);
              block.html = container.outerHTML;
              return block;
            } else {
              return false;
            }
          }
        }
      }

      function integrateSteps() {
        console.log("Integrate steps");
        const options = getOptions();
        for (let i = 0; i < options.length; i++) {
          const step = {
            blocks: [],
          };
          let stepTitle = null,
            stepImage = null;
          for (let j = 0; j < options[i].length; j++) {
            const normalBlock = renderBlock(options[i][j], false);
            if (normalBlock !== false) {
              const block = {
                id: normalBlock.id,
                html: normalBlock.html,
                name: normalBlock.name,
                value: null,
              };
              if (j === 0) {
                stepImage = normalBlock.image;
                stepTitle = block.name;
              }
              step.blocks.push(block);
              if (normalBlock.customProperty) {
                const cloneBlock = renderBlock(options[i][j], true);
                step.blocks.push({
                  id: cloneBlock.id,
                  html: cloneBlock.html,
                  name: cloneBlock.name,
                  value: null,
                });
              }
            }
          }
          if (stepTitle !== null) {
            step.title = stepTitle;
            step.image = stepImage;
            customization.steps.push(step);
          }
        }
      }

      function newCustomization() {
        console.log("New customization");
        customization = {
          extras: [
            {
              variant: 39772694839378,
              customizations: [
                {
                  id: "test1",
                  name: "Logo 1",
                  type: "file",
                  value: "#Club-Logo",
                },
              ],
            },
          ],
          html: "",
          properties: [],
          sku: {
            model: currentSKU.split("-")[0],
            size: currentSKU.split("-")[1],
            sport: currentSKU.split("-")[2],
            pack: currentSKU.split("-")[3],
          },
          steps: [],
          token:
            Math.random().toString(36).substring(2) +
            Math.random().toString(36).substring(2) +
            Math.random().toString(36).substring(2),
        };
      }

      function updateProperties(event) {
        console.log("Update properties");
        const block = event.target,
          id = block.getAttribute("cid"),
          name = block.getAttribute("cname"),
          type = block.getAttribute("ctype");
        let value;
        switch (type) {
          case "select":
            value = block.options[block.selectedIndex].value;
            break;
          case "text":
          case "textarea":
            value = block.value;
            break;
          case "radio":
          case "cross_sale":
            const checkedRadio = document
              .querySelector(`[cid="${id}"]`)
              .closest(".SizeSwatchList")
              .querySelector(`input:radio[name="${name}"]:checked`);
            value = parseInt(checkedRadio.value, 10);
            break;
        }
        for (const step of customization.steps) {
          for (const stepBlock of step.blocks) {
            if (stepBlock.id === id) {
              stepBlock.value = value;
            }
          }
        }
        console.log(customization);
      }

      function populatePopup() {
        console.log("Populate popup");
        savedSku = currentSKU;
        $("#CustomizationPopupHorizontalScroll").html(customization.html);
        $(".CustomizationPopupStepTitle").each(function () {
          $(this).addClass("Heading").addClass("u-h3");
        });
        $("[cid]").change(function () {
          updateProperties($(this));
        });
        currentStep = 0;
      }

      function differentCutomizations() {
        console.log("Different customization");
        return true;
      }

      function combineCustomization() {
        console.log("Combine customization");
      }

      function initCustomization() {
        console.log("Init customization");
        //debugger;
        if (savedSku == null) {
          newCustomization();
          integrateSteps();
          renderSteps();
          populatePopup();
          stepsWidth();
          updateStepOptions();
        } else {
          if (savedSku != currentSKU) {
            if (differentCutomizations()) {
              combineCustomization();
              populatePopup();
              stepsWidth();
              updateStepOptions();
            }
          } else {
            console.log("Open same customization");
          }
        }
        console.log(customization);
      }

      $("#CustomizationPopup").click(function () {
        $("body").toggleClass("no-scroll");
        initCustomization();
        console.log("Open popup");
        $("#CustomizationPopupWrapper").fadeTo(
          customizationAnimationDuration,
          1
        );
      });

      function hightlightError(block) {
        console.log("Hightlight error");
        //console.log("Error");
        $(".CustomizationPopupError").addClass("CustomizationPopupErrorShow");
        setTimeout(function () {
          $(".CustomizationPopupError").removeClass(
            "CustomizationPopupErrorShow"
          );
        }, customizationAnimationDuration * 5);
        block.addClass("CustomizationPopupErrorField");
        $(block).click(function () {
          $(this).removeClass("CustomizationPopupErrorField");
        });
      }

      function validadedStep() {
        console.log("Validate step");
        var result = true;
        var blocks = $(".CustomizationPopupStep")
          .eq(currentStep)
          .find(".Form__Validate");
        for (let i = 0; i < blocks.length; i++) {
          if (
            blocks.eq(i).val() == null &&
            blocks.eq(i).attr("validate") == "required"
          ) {
            //hightlightError(blocks.eq(i));
            result = false;
          }
        }
        //return result;
        return true;
      }

      // Attach the event listener to a parent element (e.g., form)
      document.addEventListener("DOMContentLoaded", function () {
        const parentElement = document.querySelector(".Form__Validate");
        if (parentElement) {
          parentElement.addEventListener("input", updateProperties);
        } else {
          console.error("Parent element not found.");
        }
      });

      function updateStepOptions() {
        console.log("Update step options");
        $(".CustomizationPopupProgressBarCurrent").css(
          "width",
          ((currentStep + 1) * 100) / customization.steps.length + "%"
        );
        if (currentStep == 0) {
          $('.CustomizationPopupButtonsStepControl[step="previous"]').fadeTo(
            customizationAnimationDuration / 3,
            0.3
          );
        } else if (currentStep == customization.steps.length - 1) {
          $('.CustomizationPopupButtonsStepControl[step="next"]').fadeTo(
            customizationAnimationDuration / 3,
            0.3
          );
        } else {
          $(".CustomizationPopupButtonsStepControl").fadeTo(
            customizationAnimationDuration / 3,
            1
          );
        }
      }

      function changeStep(next) {
        console.log("Change step");
        if (
          $("#CustomizationPopupHorizontalScroll").attr("scrolling") == "false"
        ) {
          $("#CustomizationPopupHorizontalScroll").attr("scrolling", "true");
          var horizontalScrollWidthTotal = $(
            "#CustomizationPopupHorizontalScroll"
          ).width();
          var horizontalScrollWidth =
            horizontalScrollWidthTotal / customization.steps.length;
          var horizontalScrollCurrent = parseFloat(
            $("#CustomizationPopupHorizontalScroll").css("margin-left")
          );
          var calculatedMarginLeft;
          if (next) {
            calculatedMarginLeft =
              horizontalScrollCurrent - horizontalScrollWidth;
            currentStep++;
            updateStepOptions();
          } else {
            calculatedMarginLeft =
              horizontalScrollCurrent + horizontalScrollWidth;
            currentStep--;
            updateStepOptions();
          }
          $("#CustomizationPopupHorizontalScroll").css(
            "margin-left",
            calculatedMarginLeft + "px"
          );
          setTimeout(function () {
            $("#CustomizationPopupHorizontalScroll").attr("scrolling", "false");
          }, customizationAnimationDuration +
            customizationAnimationDuration * 0.15);
        }
      }

      $(".CustomizationPopupButtonsStepControl").click(function () {
        console.log("Init step control");
        if ($(this).attr("step") == "next") {
          if (validadedStep() && currentStep < customization.steps.length - 1) {
            changeStep(1);
          }
        } else {
          if (currentStep > 0) {
            changeStep(0);
          }
        }
      });

      $(".CustomizationPopupButtonsClose").click(function () {
        console.log("Close popup");
        $("body").toggleClass("no-scroll");
        $("#CustomizationPopupWrapper").fadeTo(
          customizationAnimationDuration,
          0,
          function () {
            $("#CustomizationPopupWrapper").hide();
          }
        );
      });
    }

    // Add extras to cart
    /*async function sendForm(id, customizations) {
              const data = new FormData();
              data.append("id", id);
              for (let i = 0; i < customizations.length; i++) {
                if (customizations[i].type == "text") {
                  data.append("properties[" + customizations[i].id + "_" + customizations[i].name + "]", customizations[i].value);
                }
                else if (customizations[i].type == "file") {
                  var file = document.querySelector(customizations[i].value);
                  data.append("properties[" + customizations[i].id + "_" + customizations[i].name + "]", file.files[0]);
                }
              }
              const result = await fetch(window.Shopify.routes.root + "/cart/add.json", {
                  method: "POST",
                  body: data
              });
              return result.json();
          }
          for (let i = 0; i < extras.length; i++) {
            const result = await sendForm(extras[i].id, extras[i].customizations);
            console.log(result);
          }*/

    // Prevent main form submit to add extras to cart
    /*$('form').submit(function(event) {
            var form = this;
            event.preventDefault();
            function resumeSubmit() {
              form.submit();
            }
            resumeSubmit();
            addExtrasToCart(extras, resumeSubmit());
          }); */

    // Move label "+.." to below price
    function plusToBellow() {
      $(".ProductItem__LabelList").each(function () {
        var parent = $(this).parent();
        $(this).detach().appendTo(parent);
      });
    }
    plusToBellow();
    setTimeout(plusToBellow(), 3000);

    // Model-viewer attributes
    if ($("model-viewer").length) {
      $("model-viewer").each(function (i) {
        $(this).attr("shadow-intensity", "1");
        $(this).attr("enable-pan", "true");
        $(this).attr("environment-image", "neutral");
        $(this).attr("ar-scale", "auto");
        $(this).attr("background-color", "#f5f5f5");
        $(this).attr("auto-rotate", "true");
        //$(this).attr("auto-rotate-delay","1500");
        $(this).attr("autoplay", "true");
        $(this).attr("camera-controls", "true");
        $(this).attr("ar", "true");
        $(this).attr("ar-modes", "webxr scene-viewer quick-look");
        $(this).attr("seamless-poster", "true");
        $(this).attr("modelCacheSize", "15");
        $(this).attr("powerPreference", "high-performance");
        $(this).attr("xr-environment", "true");
        $(this).attr("bounds", "tight");
        $(this).attr("exposure", "1.15");
        $(this).attr("min-field-of-view", "50deg");
        $(this).attr("tone-mapping", "commerce");
        //$(this).prop("unstable-webxr");
        if (window.location.href.indexOf("sticker") > -1) {
          $(this).attr("ar-placement", "wall");
          $(this).attr("shadow-intensity", "0");
        }
      });
      /*
          //getDimensions()
          //$('.orbit-model').removeAttr("auto-rotate");
          //$('.orbit-model').removeAttr("camera-controls");
          //$('.orbit-model').attr("style","width: 100%;");
          //$('.orbit-model-2').attr("camera-orbit","calc(-1.5rad + env(window-scroll-y) * 4rad) calc(0deg + env(window-scroll-y) * 180deg) calc(3m - env(window-scroll-y) * 1.5m)");
          //$('.orbit-model').attr("camera-orbit","calc(0deg + env(window-scroll-y) * 2 * 180deg) 0 0");
          //$('.orbit-model').attr("style","width: 100%;height: 50vh;margin: 0 0 0px 0;");
          /*
            (() => {
              const modelViewer = document.querySelector('.orbit-model');
              const orbitCycle = [
                '45deg 55deg 0.5m',
                '-60deg 110deg 0.25m',
                '-00deg 90deg 0.125m',
                '60deg 110deg 0.25m',
                modelViewer.cameraOrbit
              ];
              setInterval(() => {
                const currentOrbitIndex = orbitCycle.indexOf(modelViewer.cameraOrbit);
                modelViewer.cameraOrbit =
                    orbitCycle[(currentOrbitIndex + 1) % orbitCycle.length];
              }, 1500);
            })();
          */
    }

    // Remove atribute from converter
    $(".converterToCM").removeAttr("onclick");

    // Opacity variable for inactive variantes
    var inactive_opacity = 0.2;

    // Criar link para pevisualizar o tamanho em realidade aumentada
    $(".sizes-box").each(function () {
      var size = $(this).data("medida");
      var sizeL = size.split("l").pop().split("w")[0];
      var sizeW = size.split("w").pop().split("h")[0];
      var sizeH = size.split("h").pop().split("k")[0];
      var sizeN = size.split("n").pop().split("l")[0];
      $(this).children(".sizes-text").children(".medida.cm.l").text(sizeL);
      $(this)
        .children(".sizes-text")
        .children(".medida.cm.l")
        .data("valor", sizeL);
      $(this).children(".sizes-text").children(".medida.cm.w").text(sizeW);
      $(this)
        .children(".sizes-text")
        .children(".medida.cm.w")
        .data("valor", sizeW);
      $(this).children(".sizes-text").children(".medida.cm.h").text(sizeH);
      $(this)
        .children(".sizes-text")
        .children(".medida.cm.h")
        .data("valor", sizeH);
      $(this)
        .children(".sizes-text")
        .children(".medida.n")
        .text(sizeN + " - ");
      var href =
        "https://size.link/?l=" +
        sizeL +
        "&w=" +
        sizeH +
        "&h=" +
        sizeW +
        "&units=cm";
      //console.log(href);
      $(this)
        .children(".sizes-text")
        .children(".sizes-link")
        .attr("href", href);
    });

    // Adicionar id ao acordião "Shipping and Delivery"
    //$('.Product__Tabs .Collapsible:nth-child(5)').attr("id", "freeShipping");

    // Adicionar butão do "Free Shipping" ao lado do preço
    if (window.location.href.indexOf("manufacturing") > -1 == false) {
      $(".ProductMeta__Price.Price.Text--subdued").append(
        '<a href="#freeShipping" onclick="freeShipping()"><span class="ProductMeta__Box-discount freeShipping" data-icon="l-truck"><ls-static-496083>Free Shipping*</ls-static-496083></span></a>'
      );
    }

    // Create "inactive" buttons on dressing room board
    if (window.location.href.indexOf("dressing-room-board") > -1) {
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul"
      ).reverseChildren();

      // When page loads
      if (
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2) input[checked='checked']"
        ).length
      ) {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(3)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      }

      // When option clicked
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(1)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(2)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(3)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(4)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", 1);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(5)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", 1);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(3)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(2)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(1)"
        ).fadeTo("fast", 1);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(3)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      });
    }

    // Create "inactive" buttons on planning board
    if (window.location.href.indexOf("planning") > -1) {
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul"
      ).reverseChildren();
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul"
      ).reverseChildren();

      // When page loads
      if (
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(5) input[checked='checked']"
        ).length
      ) {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      }
      if (
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(4) input[checked='checked']"
        ).length
      ) {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      }
      if (
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(3) input[checked='checked']"
        ).length
      ) {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      }
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(5)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      });

      // When option clicked
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(4)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(5)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", inactive_opacity);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(3)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", inactive_opacity);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(2)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", 1);
      });
      $(
        ".ProductForm__Variants .ProductForm__Option:nth-child(1) ul li:nth-child(1)"
      ).click(function () {
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(3)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(2)"
        ).fadeTo("fast", 1);
        $(
          ".ProductForm__Variants .ProductForm__Option:nth-child(2) ul li:nth-child(1)"
        ).fadeTo("fast", 1);
      });
    }

    // Mover descrição de produto
    $(".ProductMeta__Description").detach().insertAfter($(".ProductForm"));
  }
  // End product pages

  // Collections pages ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (window.location.href.indexOf("collection") > -1) {
    // Move label "+.." to below price
    function plusToBellow() {
      $(".ProductItem__LabelList").each(function () {
        var parent = $(this).parent();
        $(this).detach().appendTo(parent);
      });
    }
    plusToBellow();
    setTimeout(plusToBellow(), 3000);
  }
  // End collections page

  // Blog pages ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (window.location.href.indexOf("blogs") > -1) {
    // Ajustar imagem de treinador à imagem do artigo
    $(".ArticleItem").each(function (i) {
      var tal = $(this).children(".ArticleItem__ImageWrapper").height();
      var heightTotal = (tal / 3) * 2;
      $(this)
        .children(".ArticleItem__Content")
        .children(".Article__Author3")
        .css("height", heightTotal + "px");
      var ach = $(this)
        .children(".ArticleItem__Content")
        .children(".Article__Author3")
        .height();
      var ache = ach;
      var coisoTotal = tal - heightTotal;
      $(this)
        .children(".ArticleItem__Content")
        .children(".Article__Author3")
        .css("top", coisoTotal + "px");
    });

    // Escurecer imagem principal do artigo do blog
    $(window).scroll(function () {
      //var pixelstop = 100+100*$(window).scrollTop()/$(window).height();
      var pixelstop = 100 - $(window).scrollTop() * 0.15;
      $(".Article__ImageWrapper").css(
        "filter",
        "brightness(" + pixelstop + "%)"
      );
    });

    // Outros
    $(".rb_continue_button").addClass("btn");
    $(".rb_continue_button").addClass("btn-checkout");
    $(".rb_continue_button").addClass("helvetica");
    $(".rb_continue_button").addClass("text-link-blog");
    $(".rb_title").addClass("h3");
    $("#relatedblogs.row.h2").addClass("text-center");
    var $caralho = $(".return-link").data("proximo");
    $("#relatedblogs.row.h2").html($caralho);
  }
  // End blog pages

  // Search pages ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (window.location.href.indexOf("search") > -1) {
    // Move label "+.." to below price
    function plusToBellow() {
      $(".ProductItem__LabelList").each(function () {
        var parent = $(this).parent();
        $(this).detach().appendTo(parent);
      });
    }
    plusToBellow();
    setTimeout(plusToBellow(), 3000);
  }
  // End search pages

  // All pages ————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————————
  if (window.location.href.indexOf("onesports.pt") > -1) {
    //window.location.replace("https://www.sportstraining.pt/pt-pt");
  }
  if (window.location.href.indexOf("sportstraining") > -1) {

    // Concent cookies policy
    /*function changeCookieBanner() {
      $('[onclick="handleDecline()"]').hide();
      $(
        "#cookies-banner button:nth-child(2), #cookies-banner button:nth-child(3)"
      ).addClass([
        "ProductForm__CustomizeSimple",
        "Button",
        "Button--primary",
        "Button--tiny",
      ]);
      $('[onclick="handleDecline()"]').attr("onclick", "handleAccept()");
      var HTMLspan = $("#cookies-banner span").html() + "";
      $("#cookies-banner span").html(HTMLspan);
    }

    function getBannerEl() {
      return document.getElementById("cookies-banner");
    }

    function hideBanner(res) {
      getBannerEl().style.display = "none";
    }

    function showBanner() {
      getBannerEl().style.display = "block";
    }

    function handleAccept(e) {
      window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);
      document.addEventListener("trackingConsentAccepted", function () {
        console.log("trackingConsentAccepted event fired");
        getBannerEl().style.display = "none";
      });
    }

    function handleDecline() {
      window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);
      console.log("trackingConsentDeclined event fired");
    }

    function initCookieBanner() {
      const userCanBeTracked =
        window.Shopify.customerPrivacy.userCanBeTracked();
      const userTrackingConsent =
        window.Shopify.customerPrivacy.getTrackingConsent();
      if (!userCanBeTracked && userTrackingConsent === "") {
        showBanner();
      }
    }
    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      function (error) {
        if (error) {
          throw error;
        }
        initCookieBanner();
        changeCookieBanner();
      }
    );*/

    // Reorder logo, menu button, ...
    // Mostrar translate dropdown em todos os dispositivos
    // Trocar nome dos idiomas por icon
    // Mostrar account icon em todos os breaking points
    if ($(window).width() < 1140) {
      $(".Header__Wrapper .Header__Logo")
        .detach()
        .appendTo($(".Header__Wrapper .Header__FlexItem:nth-child(1)"));
      $('.Header__Wrapper [data-action="open-drawer"]')
        .detach()
        .appendTo($(".Header__Wrapper .Header__FlexItem:nth-child(3)"));
      //$('.Header__Wrapper [href*="/account"]').removeClass("hidden-phone");
      $(".Header__Wrapper .Header__FlexItem:nth-child(3) .HorizontalList")
        .removeClass("hidden-pocket")
        .removeClass("hidden-lap");
      //$('.Header__Wrapper .Header__FlexItem:nth-child(3) #localization_form_header').removeClass("hidden-pocket").removeClass("hidden-lap");
      var translate_icon =
        '<a href="#" class="Header__Icon Icon-Wrapper Icon-Wrapper--clickable"><svg class="Icon" style="position: unset; height: 20px !important; width: 20px !important;" viewBox="0 0 24 24" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54 0 .99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54 0-.99.45-.99.99 0 .55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69 0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03 0 1.42.39.39 1.02.39 1.42 0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6 0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39 0 .74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65 0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7l1.62-4.33L19.12 17h-3.24z"/></svg></a>';
      var html_lang_button =
        '<svg class="Icon Icon--select-arrow feather-icon zoom-1-50" viewBox="0 0 24 24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      var html_lang_text = $(
        ".Header__FlexItem:nth-child(3) #localization_form_header .SelectButton"
      ).text();
      /*if ($(window).width() < 800) {
              $('.Header__FlexItem:nth-child(3) #localization_form_header .SelectButton').html(translate_icon + html_lang_button);
            }
            else {
              $('.Header__FlexItem:nth-child(3) #localization_form_header .SelectButton').html(html_lang_text + html_lang_button);
            }*/
      $(".PageOverlay").css("z-index", "5");
    }

    // Redirect customers to other contacts
    // Link example: https://www.sportstraining.pt/?via=tel&tel=+351966203279"
    // Link example: https://www.sportstraining.pt/?via=sms&sms=+351966203279"
    // Link example: https://www.sportstraining.pt/?via=email&temail=+351966203279"
    function GetUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split("&");
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] == sParam) {
          return sParameterName[1];
        }
      }
    }
    var via = GetUrlParameter("via");
    setTimeout(function () {
      if (via == "tel") {
        var tel = GetUrlParameter("tel");
        location.replace("tel:" + tel);
        setTimeout(function () {
          location.replace(
            document.location.protocol + "//" + document.location.host
          );
        }, 1000);
      } else if (via == "sms") {
        var sms = GetUrlParameter("sms");
        location.replace("sms:" + sms);
      } else if (via == "email") {
        var email = GetUrlParameter("email");
        location.replace("mailto:" + email);
      }
    }, 0);

    // Mudar cor do botão ATC quando se clicar numa variante
    $(".ProductForm__Option").click(function () {
      setTimeout(function () {
        if ($(".ProductForm__AddToCart").attr("disabled") != "disabled") {
          $(".ProductForm__AddToCart").addClass("atc_clicked");
          setTimeout(function () {
            $(".ProductForm__AddToCart").removeClass("atc_clicked");
          }, 300);
        }
      }, 10);
    });

    /*// Languages functions
    if (
      window.location.href == "https://www.sportstraining.coach/pt-pt" ||
      window.location.href == "https://www.sportstraining.coach/pt-pt/"
    ) {
      window.location.replace("https://www.sportstraining.coach/pt");
    }
    if (window.location.href.indexOf("?lang=en") > -1) {
      localStorage.removeItem("lang");
      localStorage.setItem("lang", "en");
    } else if (window.location.href.indexOf("/de") > -1) {
      localStorage.removeItem("lang");
      localStorage.setItem("lang", "de");
    } else if (window.location.href.indexOf("/es") > -1) {
      localStorage.removeItem("lang");
      localStorage.setItem("lang", "es");
    } else if (window.location.href.indexOf("/fr") > -1) {
      localStorage.removeItem("lang");
      localStorage.setItem("lang", "fr");
    } else if (window.location.href.indexOf("/pt") > -1) {
      localStorage.removeItem("lang");
      localStorage.setItem("lang", "pt");
    }

    var lang = localStorage.getItem("lang");
    var langR = sessionStorage.getItem("lang-redirected");

    if (lang != null && lang != "en" && langR == null) {
      if (
        document.location.href.indexOf("/de") === -1 &&
        document.location.href.indexOf("/es") === -1 &&
        document.location.href.indexOf("/fr") === -1 &&
        document.location.href.indexOf("/pt") === -1
      ) {
        if (
          window.location.href.indexOf("sportstraining.de") > -1 ||
          window.location.href.indexOf("sportstraining.es") > -1 ||
          window.location.href.indexOf("sportstraining.fr") > -1 ||
          window.location.href.indexOf("sportstraining.pt") > -1
        ) {
          lang += "-pt";
        }
        //sessionStorage.setItem("lang-redirected", "true");
        window.location.replace(
          document.location.protocol +
            "//" +
            document.location.host +
            "/" +
            lang +
            document.location.pathname
        );
      }
    }
    $(
      "button[value='en'], .recommendation-modal__container, .recommendation-modal__button, .recommendation-modal__selector, .locale-bar__button, .locale-bar__selector"
    ).click(function () {
      localStorage.removeItem("lang");
    });
    if (window.location.pathname.startsWith("/de")) {
      //console.log("de");
    } else if (window.location.pathname.startsWith("/es")) {
      //console.log("es");
    } else if (window.location.pathname.startsWith("/fr")) {
      //console.log("fr");
    } else if (window.location.pathname.startsWith("/pt")) {
      //console.log("pt");
    } else {
      //console.log("en");
    }*/

    // Add designer to footer
    $(".Footer__Copyright").append(
      '<span class="Footer__StoreName"> — developed by <a href="https://www.alexandrebuxo.com">Alexandre Buxo</a></span>'
    );

    // Targets all textareas with class "txta"
    let textareas = document.querySelectorAll(".textareapim"),
      hiddenDiv = document.createElement("div"),
      content = null;
    // Adds a class to all textareas
    for (let j of textareas) {
      j.classList.add("txtstuff");
    
    hiddenDiv.classList.add("txta");
    hiddenDiv.style.display = "none";
    hiddenDiv.style.whiteSpace = "pre-wrap";
    hiddenDiv.style.wordWrap = "break-word";
    for (let i of textareas) {
      (function (i) {
        i.addEventListener("input", function () {
          i.parentNode.appendChild(hiddenDiv);
          i.style.resize = "none";
          i.style.overflow = "hidden";
          content = i.value;
          content = content.replace(/\n/g, "<br>");
          hiddenDiv.innerHTML = content + '<br style="line-height: 3px;">';
          hiddenDiv.style.visibility = "hidden";
          hiddenDiv.style.display = "block";
          i.style.height = hiddenDiv.offsetHeight + 30 + "px";
          hiddenDiv.style.visibility = "visible";
          hiddenDiv.style.display = "none";
        });
      })(i);
    }
    }

    // Outros
    var $paths = $("path"); // Get all paths
    for (var i = 0; i < $paths.length; i++) {
      // Iterate through each one
      var $path = $($paths[i]); // This gets a single path
      if ($path.attr("fill") == "#002663") {
        $path.css("fill", "#fff");
        $path.next().css("fill", "#000");
      }
    }
    var $dc = $(".Drawer__Container");
    $("#sidebar-menu .Drawer__Header").css(
      "margin-left",
      $dc.css("padding-left")
    );
    $("#sidebar-menu .Drawer__Header").css(
      "margin-right",
      $dc.css("padding-right")
    );
    $(".spr-review-header-title").css("text-transform", "normal");
    $(".spr-review-header-title").css("text-transform", "normal");
    $(".spr-review-header-title").css("letter-spacing", "inherit");
    $(".spr-review-header-title").css("margin-top", "-5px");
    $(".Icon-Wrapper[data-drawer-id='sidebar-menu']").click(function () {
      var dooo = $("#sidebar-menu").data("hidden");
      if (dooo == "true") {
        $("#shopify-section-announcement").slideDown();
      } else {
        $("#shopify-section-announcement").slideDown();
      }
    });
    $("#wh-widget-send-button").hide();
    //$(".Newsletter__Inner .Form__Input1").click(function() { $(".rstName").slideDown(); });
    //$(".rstName").click(function() { $(".lstName").slideDown(); });
    /*
        var currentDatet = new Date();
        var currentHourt = currentDatet.getHours();
        if(currentHourt>19 || currentHourt<9) {
            $("#button_online").remove();
        }
    */
    $("#shopify-chat").delay(100).attr("onclick", "fbq('track', 'Contact')");
    $("#AppleBusinessChat")
      .delay(100)
      .attr("onclick", "fbq('track', 'Contact')");
    //$('.wrapper').attr("onclick", "fbq('track', 'Contact')");
    $(".conjuntocoiso").slideUp(600);
    $(".textareapim").click(function () {
      $(".conjuntocoiso").slideDown(600);
    });
    if ($(window).width() < 640) {
      var cpr = $(".Container").css("padding-right");
      //console.log(cpr)
      $(".Blog__TagList").css("right", "-" + cpr);
      $(".Blog__TagList").css("left", "-" + cpr);
      $(".Blog__TagList").css("margin-right", "0px");
      $(".Blog__TagList").css("margin-left", "0px");
      $(".sportsModal-sport").toggleClass("Button--tiny");
      $(".sportsModal-sport").toggleClass("Button--small");
    }

    // Replace "Example Chealsea FC"
    setTimeout(function () {
      $(".stamped-review-options").each(function (i) {
        var value = " (example: Chelsea F.C.)";
        if ($(this).html().includes(value)) {
          $(this).html($(this).html().replaceAll(value, ""));
        }
      });
    }, 2000);

    // Apply styles to indicatiores inside html elements
    /*function applyTextStyles(styleMapping) {
      var textNodes = $("* :not(script,style)").contents().filter(function() {
          return this.nodeType == 3;
      });
      textNodes.each(function() {
          var text = $(this).text();
          var newText = text;
          
          // Dynamic handling of styles based on the styleMapping object
          $.each(styleMapping, function(indicator, styles) {
              var styleAttributes = $.map(styles, function(value, key) {
                  return key + ':' + value;
              }).join('; ');
              
              var regex = new RegExp("\\\\" + indicator + "(.*?)\\\\" + indicator, "g");
              newText = newText.replace(regex, '<span style="' + styleAttributes + '">$1</span>');
          });
          
          $(this).replaceWith(newText);
      });
    }
    applyTextStyles({
      "/x": {
          "text-decoration": "line-through"
      },
      "/red": {
          "color": "red"
      }
    });*/


    
  }
  // End all pages
});

if (window.location.href.indexOf("product") > -1) {
  function freeShipping() {
    $("#freeShipping").addClass("watchMe");
    setTimeout(function () {
      $("#freeShipping").removeClass("watchMe");
    }, 1000);
  }

  function LengthConverterToIN() {
    $(".converterToCM").attr("onclick", "LengthConverterToCM()");
    $(".medida.cm").each(function () {
      var number = $(this).data("valor");
      var numberConverted = Math.ceil(number * 0.3937);
      $(this).text(numberConverted);
    });
    $(".unidades").text(" in");
    $(".converterToIN").removeAttr("onclick");
  }

  function LengthConverterToCM() {
    $(".converterToIN").attr("onclick", "LengthConverterToIN()");
    $(".medida.cm").each(function () {
      var number = $(this).data("valor");
      $(this).html(number);
    });
    $(".unidades").text(" cm");
    $(".converterToCM").removeAttr("onclick");
  }

  function customizeWithoutCustomilyOpen() {}

  function customizeWithoutCustomilyClose() {}
}

if (window.location.href.indexOf("cart") > -1) {
  // Função para adicionar "Priority Manufactoring" ao carrinho
  function addExpress() {
    jQuery.getJSON(window.Shopify.routes.root + "cart.js", function (cart) {
      let formDataA = {
        items: [
          {
            id: 39814845890642,
            quantity: 1,
          },
        ],
      };
      //fetch(window.Shopify.routes.root + 'cart/add.js', {method: 'POST', headers:{'Content-Type': 'application/json'}, body: JSON.stringify(formDataA)}).then(response => {return response.json();}).catch((error) => {console.error('Error:', error);});
      jQuery.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/add.js",
        data: formDataA,
        dataType: "json",
        success: function () {
          location.reload();
        },
      });
    });
  }
}
